import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { isLogged } from '../../../../redux/slices/userContext/selectors';
import AddToListButton from '../../../account/Lotslists/AddToListButton/StandaloneCreate';
import { retrievePrevNext } from '../../../../services/artdbweb/lot';
import Preferences from '../../../common/Preferences';
import '../../../common/stylesheets/buttons.scss';
import A18n from '../../../common/A18n';
import './stylesheet.scss';

const Filters = ({ backUrl, idlot, period }) => {
  const logged = useSelector(isLogged);
  const [prevLot, setPrevLot] = useState({});
  const [nextLot, setNextLot] = useState({});

  useEffect(() => {
    retrievePrevNext({ idlot }).then(data => {
      setNextLot(data.nextLot);
      setPrevLot(data.prevLot);
    });
  }, [idlot]);

  return (
    <div className="container">
      <div className="lots-show-filters">
        {backUrl && (
          <a href={backUrl} className="artp-btn">
            <A18n rsx="search.drawers.lotmobile.m8" />
          </a>
        )}

        {prevLot && (
          <a href={prevLot.url} className="artp-btn">
            <i className="fa fa-angle-left" /> <A18n rsx="catalogue.show.m1" />
          </a>
        )}

        {nextLot && (
          <a href={nextLot.url} className="artp-btn">
            <A18n rsx="catalogue.show.m2" /> <i className="fa fa-angle-right" />
          </a>
        )}

        {period === 'past' && logged && <AddToListButton ids={[idlot]} newSelectionKey={idlot} className="artp-btn" />}

        <div className="filler" />

        <Preferences
          hiddenFields={{
            freshness: true,
            lotsViewFormat: true,
            artistsViewFormat: true,
            perPage: true,
          }}
          onChange={() => window.location.reload()}
        />
      </div>
    </div>
  );
};

export default Filters;
